import {
  Listbox as ListboxComponent,
  ListboxItem,
  type ListboxItemProps,
  type ListboxProps,
  ListboxSection,
} from '@heroui/react';
import type { Key } from 'react';
import { cn } from '../../cn';

type ListboxItemData = {
  key: string;
  description?: string;
  showDivider?: boolean;
  startContent?: React.ReactNode;
  endContent?: React.ReactNode;
  title: string;
  color?: ListboxItemProps['color'];
  className?: string;
};

type ListboxSectionData = {
  key: string;
  title?: string;
  items: ListboxItemData[];
};

type Props = Omit<ListboxProps, 'type' | 'placement' | 'items' | 'children'> & {
  children?: React.ReactNode;
  items?: ListboxItemProps<ListboxItemData>[];
  sections?: ListboxSectionData[];
  className?: string;
  selectedKeys?: Key[];
  onSelectionChange?: (keys: Key) => void;
  activeClassName?: string;
};

export const ListBox = ({
  items,
  sections,
  className,
  selectedKeys,
  onSelectionChange,
  activeClassName,
  ...props
}: Props) => {
  return (
    <div className={cn('', className)}>
      <ListboxComponent
        disallowEmptySelection
        aria-label='Single selection example'
        selectedKeys={selectedKeys}
        selectionMode='single'
        variant='flat'
        onSelectionChange={onSelectionChange}
        {...props}
      >
        {sections
          ? sections.map((section) => (
              <ListboxSection key={section.key} title={section.title}>
                {section.items.map((item) => (
                  <ListboxItem
                    key={item.key}
                    description={item.description}
                    showDivider={item.showDivider}
                    startContent={item.startContent}
                    endContent={item.endContent}
                    color={item.color}
                    className={cn(item.className, 'capitalize', {
                      [activeClassName || '']: selectedKeys?.includes(item.key as Key),
                    })}
                  >
                    {item.title}
                  </ListboxItem>
                ))}
              </ListboxSection>
            ))
          : (items || []).map((item) => (
              <ListboxItem
                key={item.key}
                description={item.description}
                showDivider={item.showDivider}
                startContent={item.startContent}
                endContent={item.endContent}
                color={item.color}
                className={cn(item.className, 'capitalize', {
                  [activeClassName || '']: selectedKeys?.includes(item.key as Key),
                })}
              >
                {item.title}
              </ListboxItem>
            ))}
      </ListboxComponent>
    </div>
  );
};
